// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"c4760040","85":"02e80ca7","91":"3282ac46","153":"64ec8421","358":"6e8938d1","447":"f2c0252f","504":"ae9382c9","591":"5060284d","620":"19c527fc","683":"481125d7","805":"d1b7e5d0","920":"d9640fa3"}[chunkId] + ".chunk.js";
};